import { Button as ChakraButton, ButtonProps as ChakraButtonProps } from '@chakra-ui/react';
import React from 'react';

import { trackClickEvent } from '../../../services/analytics/rudderstack';
import { logger } from '../../../services/sentry';

export type ButtonProps = ChakraButtonProps & {
  trackClick?: string;
};

export const Button = ({
  onClick = () => undefined,
  children,
  trackClick,
  ...rest
}: ButtonProps) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    try {
      if (trackClick) {
        trackClickEvent({ object: trackClick, elementType: 'button', children });
      }
    } catch (e) {
      logger.error('Button.tsx', `Error while tracking click event (${trackClick})`, '', e);
    }
    onClick(event);
  };

  return (
    <ChakraButton onClick={handleClick} {...rest}>
      {children}
    </ChakraButton>
  );
};

export default Button;
